import { apiClient, unwrap } from './apiClient';

export const settingsApi = {
  async themePreferences() {
    const response = await apiClient.get('/theme-preferences');
    return { data: unwrap(response), meta: response.meta || {} };
  },
  saveThemePreference(theme) {
    return apiClient.put('/theme-preferences', { key: 'theme', value: { theme } });
  }
};
